// Global JavaScript functionality
document.addEventListener('DOMContentLoaded', () => {
  // Handle mobile menu toggle
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const body = document.body;
  
  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      const isExpanded = mobileMenu.classList.contains('active');
      mobileMenu.classList.toggle('active');
      mobileMenuToggle.setAttribute('aria-expanded', !isExpanded);
      body.style.overflow = isExpanded ? '' : 'hidden';
    });

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
        mobileMenu.classList.remove('active');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        body.style.overflow = '';
      }
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (mobileMenu.classList.contains('active') && 
          !mobileMenu.contains(e.target) && 
          !mobileMenuToggle.contains(e.target)) {
        mobileMenu.classList.remove('active');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        body.style.overflow = '';
      }
    });
  }

  // Handle announcement bar close
  const announcementBar = document.querySelector('.announcement-bar');
  const announcementClose = document.querySelector('.announcement-bar__close');
  
  if (announcementBar && announcementClose) {
    announcementClose.addEventListener('click', () => {
      announcementBar.style.maxHeight = announcementBar.offsetHeight + 'px';
      // Force reflow
      announcementBar.offsetHeight;
      announcementBar.style.maxHeight = '0';
      announcementBar.style.padding = '0';
      announcementBar.style.margin = '0';
      
      setTimeout(() => {
        announcementBar.remove();
      }, 300);
    });
  }

  // Handle scroll events with throttling
  let lastScroll = 0;
  let ticking = false;
  const header = document.querySelector('.header');
  
  if (header) {
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentScroll = window.pageYOffset;
          
          if (currentScroll <= 0) {
            header.classList.remove('scroll-up');
            return;
          }
          
          if (currentScroll > lastScroll && !header.classList.contains('scroll-down')) {
            header.classList.remove('scroll-up');
            header.classList.add('scroll-down');
          } else if (currentScroll < lastScroll && header.classList.contains('scroll-down')) {
            header.classList.remove('scroll-down');
            header.classList.add('scroll-up');
          }
          
          lastScroll = currentScroll;
          ticking = false;
        });
        
        ticking = true;
      }
    });
  }

  // Handle touch events for mobile
  let touchStartY = 0;
  let touchEndY = 0;
  
  document.addEventListener('touchstart', (e) => {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  
  document.addEventListener('touchend', (e) => {
    touchEndY = e.changedTouches[0].clientY;
    handleSwipe();
  }, { passive: true });
  
  function handleSwipe() {
    const swipeDistance = touchEndY - touchStartY;
    const threshold = 50;
    
    if (Math.abs(swipeDistance) > threshold) {
      if (swipeDistance > 0) {
        // Swipe down - show header
        header.classList.remove('scroll-down');
        header.classList.add('scroll-up');
      } else {
        // Swipe up - hide header
        header.classList.remove('scroll-up');
        header.classList.add('scroll-down');
      }
    }
  }
}); 